export { default as BrokerageDetail } from './BrokerageDetail';
